import HistoricalSearchForm from "../components/HistoricalBankData/HistoricalSearchForm";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import {
  CBSDisplayFields,
  CBFDisplayFields,
  SISDisplayFields,
  SIFDisplayFields,
} from "../refdata/FilterOptions";
import { getExpandState } from "../common/services/Utilities";
import { All } from "../interfaces";

export function mapStateToProps({ appState }: All) {
  return {
    appState: appState.historical,
    searchPanelExpand: getExpandState(
      (appState as any)[appState.app].ui.searchPanelExpand,
      true,
    ),
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  const displayFields: any = {
    CBS: CBSDisplayFields,
    CBF: CBFDisplayFields,
    SIS: SISDisplayFields,
    SIF: SIFDisplayFields,
  };
  return {
    updateDisplay: (report: string) => {
      dispatch(actions.updateDisplayFields(displayFields[report]));
      dispatch(actions.updatePagination("pageNumber", 1));
      dispatch(actions.updateSortOrder("YEAR", "DESC"));
      dispatch(actions.searchPush());
    },
    setSearchPanelExpand: (updatedSearchPanelExpand: boolean) => {
      dispatch(actions.updateUi("searchPanelExpand", updatedSearchPanelExpand));
      dispatch(actions.searchPush());
    },
    updateLocations: (location: number[]) => {
      dispatch(actions.updateFilter("selectedStates", location));
      dispatch(actions.searchPush());
    },
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HistoricalSearchForm);
